/**
 * Icones de traco do sistema (grade 24x24, traco 1.8, pontas arredondadas).
 *
 * Um desenho so para o menu lateral, a folha do "Mais" e a barra de abas do
 * celular: os emojis que o menu usava mudavam de cara em cada aparelho e
 * brigavam de cor com o tema. Estes herdam a cor do texto (`currentColor`),
 * entao acendem junto com o item ativo.
 */
const TRACOS = {
  inicio: <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1z" />,
  painel: (
    <>
      <rect x="3.5" y="3.5" width="7" height="9" rx="1.5" />
      <rect x="13.5" y="3.5" width="7" height="5" rx="1.5" />
      <rect x="13.5" y="11.5" width="7" height="9" rx="1.5" />
      <rect x="3.5" y="15.5" width="7" height="5" rx="1.5" />
    </>
  ),
  dashboard: (
    <>
      <path d="M3.5 20.5h17" />
      <path d="M6.5 16.5v-4M11 16.5V8M15.5 16.5v-6M20 16.5V5" />
    </>
  ),
  conversas: <path d="M20 12a8 8 0 0 1-11.6 7.1L4 20l1-4.1A8 8 0 1 1 20 12z" />,
  atendimentos: (
    <>
      <rect x="5" y="4.5" width="14" height="17" rx="2.5" />
      <path d="M9 4.5V3h6v1.5M9 13l2 2 4-4.5" />
    </>
  ),
  agenda: (
    <>
      <rect x="4" y="5" width="16" height="16" rx="2.5" />
      <path d="M8 3v4M16 3v4M4 10h16" />
    </>
  ),
  contatos: (
    <>
      <circle cx="9" cy="8.5" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 5.2a3.5 3.5 0 0 1 0 6.6M18 14.5a6.5 6.5 0 0 1 3.5 5.5" />
    </>
  ),
  catalogo: (
    <>
      <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" />
      <circle cx="7.5" cy="7.5" r="1.5" />
    </>
  ),
  // Grupo de tres pessoas: a equipe da clinica (o desenho antigo era uma tesoura).
  equipe: (
    <>
      <circle cx="12" cy="7.5" r="3" />
      <path d="M6.5 20a5.5 5.5 0 0 1 11 0" />
      <circle cx="5" cy="9.5" r="2.2" />
      <path d="M1.8 18.5a3.8 3.8 0 0 1 4.3-3.7" />
      <circle cx="19" cy="9.5" r="2.2" />
      <path d="M22.2 18.5a3.8 3.8 0 0 0-4.3-3.7" />
    </>
  ),
  campanhas: (
    <>
      <path d="m3 11 16-5v12L3 14z" />
      <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </>
  ),
  ia: (
    <>
      <path d="M11 3.5 12.9 8.6 18 10.5l-5.1 1.9L11 17.5l-1.9-5.1L4 10.5l5.1-1.9z" />
      <path d="M19 3v4M17 5h4M18 16v4M16 18h4" />
    </>
  ),
  conexoes: (
    <>
      <path d="M9 2.5v5M15 2.5v5" />
      <path d="M6 7.5h12v3.5a6 6 0 0 1-12 0z" />
      <path d="M12 17v4.5" />
    </>
  ),
  licenca: (
    <>
      <circle cx="7.5" cy="15.5" r="4.5" />
      <path d="M10.7 12.3 20 3M16.5 6.5l3 3M14 9l2.5 2.5" />
    </>
  ),
  funcoes: (
    <>
      <path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1" />
      <circle cx="15" cy="6" r="2" />
      <circle cx="9" cy="12" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  textos: <path d="M4 7V4.5h16V7M9 19.5h6M12 4.5v15" />,
  backups: (
    <>
      <ellipse cx="12" cy="5.5" rx="8" ry="3" />
      <path d="M4 5.5v13c0 1.7 3.6 3 8 3s8-1.3 8-3v-13M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" />
    </>
  ),
  instalar: <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />,
  planilha: (
    <>
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <path d="M14 3v6h6M8 13h8M8 17h8M12 13v4" />
    </>
  ),
  adicionar: <path d="M12 5v14M5 12h14" />,
  organizar: (
    <>
      <rect x="3" y="9" width="6" height="6" rx="1.5" />
      <rect x="15" y="3" width="6" height="6" rx="1.5" />
      <rect x="15" y="15" width="6" height="6" rx="1.5" />
      <path d="M9 12h3m0-6v12m0-12h3m-3 12h3" />
    </>
  ),
  testar: <path d="M7 4.5v15l12-7.5z" />,
  sair: <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />,
  recolher: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2.5" />
      <path d="M9 3v18M16 10l-2 2 2 2" />
    </>
  ),
  expandir: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2.5" />
      <path d="M9 3v18M14 10l2 2-2 2" />
    </>
  ),
  // Modos de visualizacao: claro, medio e full black.
  sol: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
    </>
  ),
  contraste: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" />
    </>
  ),
  lua: <path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a6.8 6.8 0 0 0 10.5 10.5z" fill="currentColor" />,
  idioma: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.3 2.4 3.5 5.2 3.5 8.5s-1.2 6.1-3.5 8.5c-2.3-2.4-3.5-5.2-3.5-8.5s1.2-6.1 3.5-8.5z" />
    </>
  ),
  // Escudo com marca: regras da clinica (Regras Cadom).
  regras: (
    <>
      <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.4 7.5 9.5 4.3-1.1 7.5-4.9 7.5-9.5V6z" />
      <path d="m8.8 12 2.3 2.3 4.3-4.6" />
    </>
  ),
  // --- Editor do menu (fluxo) ---
  lista: <path d="M4 6h16M4 12h16M4 18h16" />,
  subir: <path d="m6 15 6-6 6 6" />,
  descer: <path d="m6 9 6 6 6-6" />,
  alerta: (
    <>
      <path d="M10.3 4 2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 4a2 2 0 0 0-3.4 0z" />
      <path d="M12 9.5v4M12 17h.01" />
    </>
  ),
  bloqueado: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m6 6 12 12" />
    </>
  ),
  enviar: <path d="M4 12 20 4l-4 16-4-6.5zM12 13.5 20 4" />,
  // --- Central de IA (no lugar dos emojis) ---
  livro: (
    <>
      <path d="M4 19.5V5a2 2 0 0 1 2-2h14v16H6a2 2 0 0 0-2 2z" />
      <path d="M4 19.5a2 2 0 0 0 2 2h14M8 7h8M8 11h6" />
    </>
  ),
  robo: (
    <>
      <rect x="4.5" y="8" width="15" height="11" rx="3" />
      <path d="M12 5v3M9.5 12.5v1M14.5 12.5v1M9.5 16.5h5M2.5 12.5v3M21.5 12.5v3" />
      <circle cx="12" cy="3.8" r="1.2" />
    </>
  ),
  agente: (
    <>
      <circle cx="12" cy="9" r="4" />
      <path d="M5 20.5a7 7 0 0 1 14 0" />
      <path d="M7 9.5a5 5 0 0 1 10 0v1M17 10.5a2.5 2.5 0 0 1-2.5 2.5H13" />
    </>
  ),
  camadas: (
    <>
      <path d="m12 3 9 4.5-9 4.5-9-4.5z" />
      <path d="m3 12 9 4.5 9-4.5M3 16.5 12 21l9-4.5" />
    </>
  ),
  atualizar: (
    <>
      <path d="M19.5 10A8 8 0 0 0 5.2 7.2L4 8.5M4 3.5v5h5" />
      <path d="M4.5 14a8 8 0 0 0 14.3 2.8l1.2-1.3M20 20.5v-5h-5" />
    </>
  ),
  raio: <path d="M13 3 5 13.5h6L10 21l8-10.5h-6z" />,
  globo: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </>
  ),
  estrela: <path d="m12 3.5 2.6 5.3 5.9.9-4.2 4.1 1 5.8L12 16.8l-5.3 2.8 1-5.8-4.2-4.1 5.9-.9z" />,
  lampada: (
    <>
      <path d="M9.5 18h5M10.5 21h3" />
      <path d="M12 3a6 6 0 0 0-3.6 10.8c.7.5 1.1 1.3 1.1 2.1v.1h5v-.1c0-.8.4-1.6 1.1-2.1A6 6 0 0 0 12 3z" />
    </>
  ),
  pacote: (
    <>
      <path d="M21 8 12 3 3 8v8l9 5 9-5z" />
      <path d="m3 8 9 5 9-5M12 13v8" />
    </>
  ),
  busca: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-4.4-4.4" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  seta: <path d="M5 12h14M13 6l6 6-6 6" />,
  fechar: <path d="M6 6l12 12M18 6 6 18" />,
  chave: (
    <>
      <circle cx="8" cy="15" r="4" />
      <path d="m10.8 12.2 9.2-9.2M16 7l3 3M18.5 4.5l2 2" />
    </>
  ),
  alvo: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" />
    </>
  ),
  lapis: (
    <>
      <path d="M4 20h4L19.5 8.5a2.1 2.1 0 0 0-4-4L4 16z" />
      <path d="m14 6 4 4" />
    </>
  ),
  ajustes: (
    <>
      <path d="M4 7h10M18 7h2M4 17h4M12 17h8" />
      <circle cx="16" cy="7" r="2" />
      <circle cx="10" cy="17" r="2" />
    </>
  ),
  historico: (
    <>
      <path d="M3.5 12a8.5 8.5 0 1 0 2.5-6" />
      <path d="M3 4v4.5h4.5M12 7.5V12l3 2" />
    </>
  ),
  sino: (
    <>
      <path d="M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z" />
      <path d="M10 20.5a2 2 0 0 0 4 0" />
    </>
  ),
  banco: (
    <>
      <ellipse cx="12" cy="5.5" rx="7.5" ry="2.5" />
      <path d="M4.5 5.5v13c0 1.4 3.4 2.5 7.5 2.5s7.5-1.1 7.5-2.5v-13M4.5 12c0 1.4 3.4 2.5 7.5 2.5s7.5-1.1 7.5-2.5" />
    </>
  ),
  chama: <path d="M12 21a6 6 0 0 0 6-6c0-4-3-6-4-10-2 2-3 4-3 6-1-1-1.5-2-1.5-3C7 9.5 6 12 6 15a6 6 0 0 0 6 6z" />,
  olho: (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  mais: (
    <>
      <rect x="4" y="4" width="6.5" height="6.5" rx="1.5" />
      <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5" />
      <rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5" />
    </>
  )
};

export function Icone({ nome, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {TRACOS[nome]}
    </svg>
  );
}

/** O raio da marca — o mesmo do icone do app instalado e do favicon. */
export function Raio() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path d="M18 5 9 18h6l-1 9 9-13h-6z" fill="currentColor" />
    </svg>
  );
}
